import { useEffect, useState } from 'react';

const usePhotoCovered = <T extends HTMLElement>(
  bannerHeight: string,
): [boolean, (marker: T | null) => void] => {
  const [marker, setMarker] = useState<T | null>(null);
  const [isCovered, setIsCovered] = useState(false);

  useEffect(() => {
    if (!marker || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const bannerBottom = entry.rootBounds?.top ?? 0;
        setIsCovered(
          !entry.isIntersecting && entry.boundingClientRect.top < bannerBottom,
        );
      },
      { rootMargin: `-${bannerHeight} 0px 0px 0px` },
    );

    observer.observe(marker);

    return () => observer.disconnect();
  }, [marker, bannerHeight]);

  return [isCovered, setMarker];
};

export default usePhotoCovered;
